import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
};

const defaultProps = {
  className: '',
  text: '',
  icon: '',
  onClick: () => {},
};

class BbButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(evt) {
    this.props.onClick(evt);
  }

  render() {
    const {
      className,
      text,
      icon,
      ...attributes
    } = this.props;

    const classes = classNames(
      className,
      'c-bb-button',
    );

    return (
      <button className={classes} onClick={this.onClick} {...attributes}>
        {icon &&
          <i className={`ìcon icon-${icon}`} />
        }
        { text }
      </button>
    );
  }
}

BbButton.propTypes = propTypes;
BbButton.defaultProps = defaultProps;

export default BbButton;



// WEBPACK FOOTER //
// ./src/components/@browsbox-ui/bb-button/button.js